import baseOptions from '../render/baseOptions';
import mergeHighcharts, {applyDefaults} from '../render/mergeHighcharts';
import {Cube, MarkOutput, MarkRenderer, RenderContext, RenderSpec} from '../types';
import renderBar from './bar';
import renderBoxplot from './boxplot';
import renderComparison from './comparison';
import renderDiverging from './diverging';
import renderDumbbell from './dumbbell';
import renderHeatmap from './heatmap';
import renderKpi from './kpi';
import {renderArea, renderLine} from './line';
import renderMap from './map';
import renderPie from './pie';
import renderRadar from './radar';
import renderRanking from './ranking';
import renderSankey from './sankey';
import renderScatter from './scatter';
import renderSunburst from './sunburst';
import renderTreemap from './treemap';

export const markRenderers: Record<string, MarkRenderer> = {
    bar: renderBar,
    line: renderLine,
    area: renderArea,
    pie: renderPie,
    kpi: renderKpi,
    heatmap: renderHeatmap,
    diverging: renderDiverging,
    scatter: renderScatter,
    dumbbell: renderDumbbell,
    sankey: renderSankey,
    treemap: renderTreemap,
    sunburst: renderSunburst,
    boxplot: renderBoxplot,
    radar: renderRadar,
    map: renderMap,
    ranking: renderRanking,
    comparison: renderComparison,
};

export class UnsupportedMarkError extends Error {
    constructor(public readonly mark: string) {
        super(`Unsupported mark '${mark}'`);
        Object.setPrototypeOf(this, UnsupportedMarkError.prototype); // instanceof survives ES5 targets
    }
}

/** base look -> mark -> spec.highcharts override (always last, so it can retouch anything the mark produced). */
export function renderMark(cube: Cube, spec: RenderSpec, ctx: RenderContext): MarkOutput {
    const renderer = Object.prototype.hasOwnProperty.call(markRenderers, spec.mark) ? markRenderers[spec.mark] : null;
    if (!renderer) {
        throw new UnsupportedMarkError(spec.mark);
    }

    const output = renderer(cube, spec, ctx);

    return output.type === 'highcharts'
        ? {type: 'highcharts', options: mergeHighcharts(applyDefaults(baseOptions(), output.options), spec.highcharts)}
        : output;
}
